var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "444px",
    height: "187px",
    viewBox: "0 0 444 187",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Adme White") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 99.2671379 0 99.2671379 185.42 0 185.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "1.38777878e-14 3.99680289e-15 330.473 3.99680289e-15 330.473 185.42 1.38777878e-14 185.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "3.05311332e-15 -2.2759572e-15 244.192 -2.2759572e-15 244.192 144.736 3.05311332e-15 144.736"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-7",
    points: "3.05311332e-15 -2.2759572e-15 244.192 -2.2759572e-15 244.192 144.736 3.05311332e-15 144.736"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Adme-White",
    transform: "translate(0.000318, 0.434314)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-1-Clipped",
    transform: "translate(0.000000, 0.520000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3226818,141.44 L49.4526818,37.74 L64.8336818,141.44 L34.3226818,141.44 Z M67.2026818,0.82 C67.1126818,0.35 66.7026818,0 66.2136818,0 L32.6226818,0 C32.1336818,0 31.7136818,0.35 31.6336818,0.83 L0.0136817882,184.31 C-0.0873182118,184.92 0.383681788,185.48 1.00368179,185.48 L27.0326818,185.48 C27.5226818,185.48 27.9426818,185.119 28.0226818,184.63 L30.4826818,167.74 L68.7326818,167.74 L71.1226818,183.78 C71.2636818,184.76 72.1126818,185.48 73.1036818,185.48 L98.2636818,185.45 C98.8836818,185.44 99.3536818,184.88 99.2536818,184.27 L67.2026818,0.82 L67.2026818,0.82 Z",
    id: "Fill-1",
    fill: "#000000",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M216.998933,186 C216.448346,186 215.999682,185.553631 215.999682,185.003641 L215.999682,160.996359 C215.999682,160.446369 216.448346,160 216.998933,160 L443.000431,160 C443.553017,160 443.999682,160.446369 443.999682,160.996359 L443.999682,185.003641 C443.999682,185.553631 443.553017,186 443.000431,186 L216.998933,186 Z",
    id: "Fill-4",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Fill-7-Clipped",
    transform: "translate(113.133682, 0.520000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.609,86.64 L58.63,124.03 L58.599,139.64 C58.479,143.57 57.92,147.11 56.659,149.57 C56.03,150.8 55.319,151.75 54.639,152.63 C53.979,153.51 53.269,154.33 52.349,155.14 C51.45,155.97 50.28,156.71 48.92,157.43 C47.54,158.119 45.929,158.68 44.2,159.08 C43.33,159.28 42.429,159.44 41.53,159.51 L40.859,159.55 L40.5,159.56 L40.019,159.57 L38.059,159.59 L30.25,159.68 L27.95,159.7 L27.95,25.78 L30.25,25.8 L38.059,25.89 L40.019,25.91 L40.5,25.92 L40.859,25.929 L41.53,25.97 C42.429,26.04 43.33,26.2 44.2,26.4 C45.929,26.8 47.54,27.36 48.92,28.05 C50.28,28.77 51.45,29.51 52.349,30.34 C53.269,31.15 53.979,31.97 54.639,32.85 C55.319,33.73 56.03,34.679 56.659,35.909 C57.92,38.369 58.479,41.909 58.599,45.84 L58.63,61.45 L58.599,83.13 L58.609,86.64 Z M86.79,83.13 L86.76,61.45 L86.79,45.79 C86.79,42.53 86.639,39.2 86.12,35.74 C85.559,32.28 84.719,28.71 83.389,25.1 C82.08,21.51 80.2,17.869 77.639,14.66 C75.08,11.46 71.909,8.71 68.54,6.57 C65.13,4.45 61.55,2.95 58.01,1.92 C54.46,0.92 51.059,0.42 47.62,0.16 C46.55,0.08 45.479,0.03 44.42,3.99680289e-15 L1.04,3.99680289e-15 C0.479,3.99680289e-15 0.04,0.44 0.04,1 L1.38777878e-14,76.52 L1.38777878e-14,86.64 L0.04,184.48 C0.04,185.04 0.479,185.48 1.04,185.48 L44.42,185.48 C45.479,185.45 46.55,185.4 47.62,185.32 C51.059,185.06 54.46,184.56 58.01,183.56 C61.55,182.53 65.13,181.03 68.54,178.91 C71.909,176.77 75.08,174.02 77.639,170.82 C80.2,167.61 82.08,163.97 83.389,160.38 C84.719,156.77 85.559,153.2 86.12,149.74 C86.639,146.28 86.79,142.95 86.79,139.69 L86.76,124.03 L86.78,86.64 L86.79,83.13 L86.79,83.13 Z",
    id: "Fill-7",
    fill: "#000000",
    fillRule: "nonzero",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-9",
    fill: "#0A0B09",
    fillRule: "nonzero",
    points: "171.504682 87 171.494682 87 171.494682 83 171.504682 87"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-10",
    fill: "#0A0B09",
    fillRule: "nonzero",
    points: "199.504682 83 199.504682 87 199.494682 87 199.504682 83"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-11",
    fill: "#0A0B09",
    fillRule: "nonzero",
    points: "171.504682 77 171.494682 84 171.494682 77 171.504682 77"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(199.418682, 0.435000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-12-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-5"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-12",
    fill: "#0A0B09",
    fillRule: "nonzero",
    mask: "url(#mask-6)",
    points: "0.505 76.605 0.505 83.215 0.495 76.605 0.505 76.605"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-14-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.022,25.639 L181.015,59.256 L210.975,59.256 C211.527,59.256 211.975,59.703 211.975,60.256 L211.975,84.456 C211.975,85.008 211.527,85.456 210.975,85.456 L181.015,85.456 L181.015,118.536 L243.184,118.529 C243.736,118.529 244.184,118.977 244.184,119.529 L244.184,143.729 C244.184,144.282 243.737,144.729 243.184,144.729 L180.755,144.736 L180.755,144.726 L154.015,144.726 C153.462,144.726 153.015,144.278 153.015,143.726 L153.022,1.075 C153.022,0.523 153.47,0.076 154.021,0.075 L243.191,-1.671e-06 C243.744,-1.671e-06 244.192,0.447 244.192,0.999998329 L244.192,24.633 C244.192,25.185 243.745,25.633 243.192,25.633 L181.022,25.639",
    id: "Fill-14",
    fill: "#000000",
    fillRule: "nonzero",
    mask: "url(#mask-8)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M337.003186,0 L311.065394,0 C310.69669,0 310.356885,0.200497788 310.177516,0.531319137 L277.004166,63.3362486 L241.619592,0.501244469 C241.440223,0.190472898 241.111379,0 240.751644,0 L216.996178,0 C216.448105,0 215.999682,0.441095133 215.999682,1.00248894 L215.999682,143.997511 C215.999682,144.558905 216.448105,145 216.996178,145 L240.353046,145 C240.91208,145 241.349542,144.558905 241.349542,143.997511 L241.360503,55.3163371 L277.004166,114.18349 L310.537251,55.3163371 L310.537251,143.997511 C310.537251,144.558905 310.985674,145 311.533747,145 L337.003186,145 C337.56222,145 337.999682,144.558905 337.999682,143.997511 L337.999682,1.00248894 C337.999682,0.441095133 337.56222,0 337.003186,0",
    id: "Fill-16",
    fill: "#000000",
    fillRule: "nonzero"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.cdaaa44ff27718ae618dcda2c3eddfb3.svg";
export { ForwardRef as ReactComponent };